import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "./Reveal";

const faqs = [
    {
        q: "Do you charge any fees for your advice?",
        a: "No. Our consultation, policy comparison and claim assistance are completely free for you. We earn a regulated commission from the insurer when a policy is placed — you pay exactly the same premium as buying directly, often less after our comparisons.",
    },
    {
        q: "Which insurance companies do you work with?",
        a: "We work with 40+ IRDAI-registered insurers including LIC, HDFC Ergo, ICICI Lombard, Star Health, Tata AIG, New India Assurance, Bajaj Allianz, Cholamandalam MS and many more — across life, health and general insurance.",
    },
    {
        q: "Will you help me during a claim?",
        a: "Yes — this is where we matter most. From cashless hospitalisation coordination to motor survey follow-ups and death claim documentation, our Coimbatore team assists you end to end until settlement. We have assisted 4,800+ claims so far.",
    },
    {
        q: "Can you renew or port my existing policy from another agent?",
        a: "Absolutely. Bring us your existing policy and we will review it for gaps, compare better options across insurers, and handle the renewal or portability paperwork — including health insurance portability without losing waiting-period benefits.",
    },
    {
        q: "I run a small business in Coimbatore. What do I need?",
        a: "Most MSMEs we advise start with fire & special perils cover for the premises, group health for employees, and a liability policy. Visit us or book a call — we will audit your risks and recommend only what is necessary.",
    },
];

export const Faq = () => (
    <section id="faq" data-testid="faq-section" className="mx-auto max-w-7xl px-6 py-32 md:px-12">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12">
            <Reveal className="lg:col-span-5">
                <p className="mb-6 font-mono text-xs uppercase tracking-[0.25em] text-clay">Questions, answered</p>
                <h2 className="font-serif text-4xl font-medium leading-none tracking-tight md:text-5xl">
                    Before you <span className="italic text-clay">ask us</span>
                </h2>
                <p className="mt-8 max-w-sm text-base leading-relaxed text-moss">
                    Everything families and business owners in Coimbatore usually want to know before their first visit.
                </p>
            </Reveal>
            <Reveal delay={0.1} className="lg:col-span-7">
                <Accordion type="single" collapsible data-testid="faq-accordion" className="border-t border-line">
                    {faqs.map((f, i) => (
                        <AccordionItem key={i} value={`item-${i}`} className="border-line">
                            <AccordionTrigger data-testid={`faq-question-${i}`} className="py-6 text-left font-serif text-xl font-medium hover:text-clay md:text-2xl">
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent data-testid={`faq-answer-${i}`} className="pb-6 text-base leading-relaxed text-moss">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
);
